import {Box, Heading, Text, useMediaQuery, VStack} from "@chakra-ui/react";
import { ReactComponent as Logo } from "../../../assets/icons/authLogo.svg";
import { ReactComponent as MobileLogo } from "../../../assets/icons/mobile/authLogoMobile.svg";

export const LogoHeader = ({text, title,textFontSize = 'body.lg'}) => {
    const [isMobile] = useMediaQuery("(max-width: 1270px)");

    return (
        <>
            {isMobile ? <MobileLogo/> : <Logo/>}
            <VStack
                my={isMobile ? '24px' : '64px'}
                textAlign={'center'}>
                <Heading
                    whiteSpace={'nowrap'}
                    color={'neutral.100'}
                    fontSize={isMobile ? 'heading.3xl' : 'display.sm'}>
                    {title}
                </Heading>
                <Text
                    color={'neutral.500'}
                    fontSize={isMobile ? 'body.sm' : textFontSize}>
                    {text}
                </Text>
            </VStack>
            <Box
                position={'absolute'}
                borderRadius={'28px'}
                h={'5px'}
                top={'0'}
                w={isMobile ? '600px' : '90%'}
                m={'auto'}
                bg={'linear-gradient(90deg, #191B22 0%, #5834A8 50%, #191B21 100%)'}/>
            <Box
                position={'absolute'}
                top={'-296px'}
                borderRadius={'28px'}
                h={'600px'}
                w={'80%'}
                m={'auto'}
                bg={'radial-gradient(50% 50% at 50% 50%, rgba(88, 52, 168, 0.24) 0%, rgba(88, 52, 168, 0) 100%)'}/>
        </>
    )
}